export default __webpack_public_path__ + "static/media/milkaut.9dfb1c8a.png";